package org.catharsis.spendtel.core.platform

import org.catharsis.spendtel.feature.data.CheckoutSessionRequest
import org.catharsis.spendtel.feature.data.StoragePathInput

expect fun openCheckoutUrl(url: String)

enum class PurchaseReturn {
    Success,
    Cancelled,
}

sealed class StorePurchaseOutcome {
    data object Success : StorePurchaseOutcome()
    data object Cancelled : StorePurchaseOutcome()
    data class Failed(val message: String) : StorePurchaseOutcome()
}

expect fun usesNativeStoreBilling(): Boolean

expect suspend fun purchaseConsumableReport(): StorePurchaseOutcome

expect fun paywallPurchasingButtonText(): String

expect fun purchaseCancelledMessage(): String

expect suspend fun syncRevenueCatUser(userId: String)

expect suspend fun syncRevenueCatUserLoggedOut()

expect fun consumePurchaseReturnQuery(): PurchaseReturn?

expect fun clearPurchaseReturnQuery()

expect fun checkoutReturnPaths(): CheckoutSessionRequest

expect object PendingReportStore {
    fun save(paths: List<StoragePathInput>)
    fun load(): List<StoragePathInput>?
    fun hasPending(): Boolean
    fun clear()
}
